/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Key_OpenaiInputs */

const en_ai_key_openai = /** @type {(inputs: Ai_Key_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI API key`)
};

const de_ai_key_openai = /** @type {(inputs: Ai_Key_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI-API-Schlüssel`)
};

/**
* | output |
* | --- |
* | "OpenAI API key" |
*
* @param {Ai_Key_OpenaiInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_key_openai = /** @type {((inputs?: Ai_Key_OpenaiInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Key_OpenaiInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_key_openai(inputs)
	return en_ai_key_openai(inputs)
});